import { render, staticRenderFns } from "./FooterForm.vue?vue&type=template&id=82bd003e&scoped=true&"
import script from "./FooterForm.vue?vue&type=script&lang=js&"
export * from "./FooterForm.vue?vue&type=script&lang=js&"
import style0 from "./FooterForm.vue?vue&type=style&index=0&id=82bd003e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bd003e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VCol,VDivider,VForm,VRow})
